
import React from 'react'
import styles from './bookSummary.module.css'
import { formatDuration, formatPrice } from '../../../utils/pricing'
import { LuClock, LuPen, LuTrash2 } from "react-icons/lu";

function BookSummaryService({
    service,
    onRemoveService = () => {},
    onEditService = () => {},
}) {
    const attributes = Array.isArray(service?.selected_attributes)
        ? service.selected_attributes
        : (Array.isArray(service?.attributes) ? service.attributes : []);

    return (
        <div className={styles.serviceSummary}>
            <div className={styles.serviceHeader}>
                <h3 className={styles.serviceName}>{service.product.name}</h3>
                <span className={styles.servicePrice}>{formatPrice(service.total_price)}</span>
            </div>

            {attributes.length > 0 && (
                <ul className={styles.attributeList}>
                    {attributes.map((attribute, index) => (
                        <li key={`${attribute.attribute_name ?? 'attribute'}-${index}`} className={styles.serviceAttribute}>
                            <span className={styles.attributeName}>{attribute.attribute_name}</span>
                            <span className={styles.attributeValue}>{attribute.attribute_value}</span>
                        </li>
                    ))}
                </ul>
            )}

            <div className={styles.serviceFooter}>
                <span className={styles.serviceDuration}>
                    <LuClock aria-hidden="true" />
                    {formatDuration(service.total_duration)}
                </span>
                <div className={styles.actionRow}>
                    <button type="button" onClick={onEditService} aria-label={`Edit ${service.product.name}`}>
                        <LuPen />
                    </button>
                    <button type="button" onClick={onRemoveService} aria-label={`Remove ${service.product.name}`} className={styles.removeButton}>
                        <LuTrash2 />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default BookSummaryService
